import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { ChevronRightIcon, EditIcon, TimeIcon } from '@chakra-ui/icons';
import { Badge, Checkbox, Editable, EditableInput, EditablePreview, HStack, IconButton, Input, Stack, Text, Tooltip, VStack } from '@chakra-ui/react';
import moment from 'moment';
import * as R from 'ramda';
import API from 'src/api/API';
import { VideoActionButton } from 'src/components/Booking/VideoActionButton';
import { CopyButton } from 'src/components/Button/CopyButton';
import EnterButton from 'src/components/Button/EnterButton';
import DebouncedInput from 'src/components/DebouncedInput';
import { EditOrgClientProfile } from 'src/components/EditOrgClientProfile';
import { Select } from 'src/components/common/Form/Select';
import { TurnsIntoToVideoIcon, VideoIcon } from 'src/components/common/Icons';
import { BranchConstants, commonSettings, SURVEY_STATUS_CODES_LIST } from 'src/constants';
import { getTherapyStageOptions, getTherapyTypeOptions, getTherapyTypeText, getVisitPurposeOptions, getVisitPurposeText } from 'src/constants/booking';
import { BranchVisitStates, MenuID } from 'src/types';
import { getSurveyStatusColor, isClinic, template, utcDateString2localDateString } from 'src/utils';
import { getConsultationTreatmentWording } from 'src/utils/wording';
import { filterFnCollection } from '../Filter/filterFnCollection';
import { renderTooltipCell, TaskButton, TaskIconButton } from '../TableCell';
import { getCellValue } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var nestedAccessor = function nestedAccessor(id) {
  return function (row) {
    return getCellValue(id, row);
  };
};

var getUserName = function getUserName(id, userOptions) {
  var _userOptions$find;

  return ((_userOptions$find = userOptions.find(function (option) {
    return option.value === id;
  })) === null || _userOptions$find === void 0 ? void 0 : _userOptions$find.label) || '';
};

export var getUserColumnDef = function getUserColumnDef(id, header, t, users) {
  return {
    header: header,
    id: id,
    accessorFn: nestedAccessor(id),
    size: 160,
    cell: function cell(info) {
      var value = getUserName(info.getValue(), users);
      return /*#__PURE__*/_jsx(Tooltip, {
        label: value,
        e2eid: "Columns_BookingColumns_Tooltip",
        children: /*#__PURE__*/_jsx(Text, {
          isTruncated: true,
          e2eid: "Columns_BookingColumns_Text",
          children: value
        })
      });
    },
    filterFn: filterFnCollection.text,
    meta: {
      editable: {
        renderEditCell: function renderEditCell(value, setValue, isDisabled) {
          return /*#__PURE__*/_jsx(Select, {
            value: users.find(function (option) {
              return option.value === value;
            }),
            onChange: function onChange(option) {
              return setValue(option.value);
            },
            options: users,
            placeholder: t('common:form.pleaseSelect', '請選擇'),
            isDisabled: isDisabled,
            e2eid: "Columns_BookingColumns_Select"
          });
        }
      },
      getDisplayValue: function getDisplayValue(id) {
        return getUserName(id, users);
      },
      bulkUpdate: {
        options: users
      },
      filterVariant: 'select',
      selectFilterProps: {
        options: users,
        isCreatable: false
      }
    }
  };
};
var compileBranchVisitText = template('<%= time %> <%= booking_name %> (<%= salesperson %>/<%= dietician %>) <%= delegate %> <%= therapy_stage %> <%= visit_purposes %> <%= note %> <%= doctor %> <%= check_in_time %>');

var getBranchVisitCopiedText = function getBranchVisitCopiedText(data, userOptions) {
  var time = data.time,
      booking_name = data.info.booking_name,
      note = data.note,
      metadata = data.data,
      check_in_time = data.check_in_time;

  var _ref = metadata !== null && metadata !== void 0 ? metadata : {},
      salesperson_id = _ref.salesperson_id,
      salesperson_delegate_id = _ref.salesperson_delegate_id,
      master_dietician_id = _ref.master_dietician_id,
      master_dietician_delegate_id = _ref.master_dietician_delegate_id,
      therapy_type = _ref.therapy_type,
      therapy_stage = _ref.therapy_stage,
      visit_purposes = _ref.visit_purposes,
      doctor_id = _ref.doctor_id;

  var salesperson_delegate = getUserName(salesperson_delegate_id, userOptions);
  var dietician_delegate = getUserName(master_dietician_delegate_id, userOptions);
  var text = compileBranchVisitText({
    time: utcDateString2localDateString(time, 'HH:mm'),
    booking_name: booking_name || '',
    salesperson: getUserName(salesperson_id, userOptions),
    dietician: getUserName(master_dietician_id, userOptions),
    delegate: salesperson_delegate || dietician_delegate ? "(".concat(salesperson_delegate, "/").concat(dietician_delegate, ")") : '',
    doctor: getUserName(doctor_id, userOptions),
    therapy_type: therapy_type || '',
    therapy_stage: therapy_stage || '',
    visit_purposes: visit_purposes.join(','),
    note: note || '',
    check_in_time: moment(check_in_time).isValid() ? utcDateString2localDateString(check_in_time, 'HH:mm') : ''
  });
  return text;
};

var BranchVisitCopyButton = function BranchVisitCopyButton(_ref2) {
  var data = _ref2.data,
      userOptions = _ref2.userOptions;
  var text = getBranchVisitCopiedText(data, userOptions);
  return /*#__PURE__*/_jsx(Tooltip, {
    label: text,
    e2eid: "Columns_BookingColumns_Tooltip",
    children: /*#__PURE__*/_jsx(CopyButton, {
      getCopyText: function getCopyText() {
        return text;
      },
      e2eid: "Columns_BookingColumns_CopyButton"
    })
  });
};

export var getBookingColumns = function getBookingColumns(_ref3) {
  var t = _ref3.t,
      serviceNameList = _ref3.serviceNameList,
      _ref3$providerList = _ref3.providerList,
      providerList = _ref3$providerList === void 0 ? BranchConstants.PROVIDER_LIST : _ref3$providerList,
      isCofit = _ref3.isCofit,
      cofitProviderList = _ref3.cofitProviderList,
      _ref3$refetch = _ref3.refetch,
      refetch = _ref3$refetch === void 0 ? function () {} : _ref3$refetch,
      can = _ref3.can,
      dieticians = _ref3.dieticians,
      doctors = _ref3.doctors,
      salespeople = _ref3.salespeople,
      branchVisitChangeHandler = _ref3.branchVisitChangeHandler,
      setIsInPollingMode = _ref3.setIsInPollingMode,
      cancelHandler = _ref3.cancelHandler,
      navigate = _ref3.navigate,
      handleRecordButtonClick = _ref3.handleRecordButtonClick;
  var visitPurposeOptions = getVisitPurposeOptions(t);
  var therapyTypeOptions = getTherapyTypeOptions(t);
  var therapyStageOptions = getTherapyStageOptions(t);
  var nameAccessorKey = isClinic() ? 'info.name' : 'client.name';
  return [{
    header: t('common:normal.time', '時段'),
    id: 'time',
    accessorKey: 'time',
    size: 64,
    cell: function cell(_ref4) {
      var row = _ref4.row;
      var original = row.original;
      return original !== null && original !== void 0 && original.time ? /*#__PURE__*/_jsx(Text, {
        color: "brand",
        e2eid: "Columns_BookingColumns_Text",
        children: utcDateString2localDateString(original === null || original === void 0 ? void 0 : original.time, 'HH:mm')
      }) : null;
    }
  }, {
    header: t('common:normal.simplybook_client_name', '預約名稱'),
    id: 'info.booking_name',
    accessorFn: nestedAccessor('info.booking_name'),
    size: 160,
    cell: function cell(_ref5) {
      var row = _ref5.row,
          getValue = _ref5.getValue;
      var original = row.original;
      var value = getValue();
      return /*#__PURE__*/_jsxs(HStack, {
        justifyContent: "space-between",
        e2eid: "Columns_BookingColumns_HStack",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          label: value,
          e2eid: "Columns_BookingColumns_Tooltip",
          children: /*#__PURE__*/_jsx(Text, {
            isTruncated: true,
            e2eid: "Columns_BookingColumns_Text",
            children: value
          })
        }), /*#__PURE__*/_jsx(BranchVisitCopyButton, {
          data: original,
          userOptions: [].concat(_toConsumableArray(doctors), _toConsumableArray(dieticians), _toConsumableArray(salespeople)),
          e2eid: "Columns_BookingColumns_BranchVisitCopyButton"
        })]
      });
    },
    filterFn: filterFnCollection.text,
    meta: {
      filterVariant: 'text'
    }
  }, {
    header: t('common:normal.nameOnBookingPage', '姓名'),
    id: nameAccessorKey,
    accessorFn: nestedAccessor(nameAccessorKey),
    size: 160,
    cell: renderTooltipCell,
    filterFn: filterFnCollection.text,
    meta: {
      filterVariant: 'text'
    }
  }, {
    header: t('common:normal.record_data', '病歷資料'),
    id: 'info.record_number',
    accessorFn: nestedAccessor('info.record_number'),
    size: 130,
    cell: function cell(_ref6) {
      var _original$client, _original$client2, _original$client$org_, _original$client3, _original$client3$org, _identity$data;

      var row = _ref6.row,
          getValue = _ref6.getValue;
      var original = row.original;
      var client_id = original.client_id;

      var _ref7 = (_original$client = original === null || original === void 0 ? void 0 : original.client) !== null && _original$client !== void 0 ? _original$client : {},
          clientBirthday = _ref7.birthday,
          name = _ref7.name;

      var _ref8 = (_original$client2 = original === null || original === void 0 ? void 0 : original.client) !== null && _original$client2 !== void 0 ? _original$client2 : {},
          identities = _ref8.identities;

      var _ref9 = identities !== null && identities !== void 0 ? identities : [{
        data: {
          phone: ''
        }
      }],
          _ref10 = _slicedToArray(_ref9, 1),
          identity = _ref10[0];

      var _ref11 = (_original$client$org_ = original === null || original === void 0 ? void 0 : (_original$client3 = original.client) === null || _original$client3 === void 0 ? void 0 : (_original$client3$org = _original$client3.org_client_profiles) === null || _original$client3$org === void 0 ? void 0 : _original$client3$org[0]) !== null && _original$client$org_ !== void 0 ? _original$client$org_ : {},
          identity_number = _ref11.identity_number,
          record_number = _ref11.record_number,
          gender = _ref11.gender,
          birthday = _ref11.birthday,
          real_name = _ref11.real_name,
          special_note = _ref11.special_note,
          allergy_note = _ref11.allergy_note,
          id = _ref11.id,
          street = _ref11.street,
          country = _ref11.country,
          city = _ref11.city;

      return /*#__PURE__*/_jsxs(HStack, {
        w: "full",
        justify: "space-between",
        e2eid: "Columns_BookingColumns_HStack",
        children: [/*#__PURE__*/_jsx(Text, {
          e2eid: "Columns_BookingColumns_Text",
          children: getValue() || t('common:normal.recordNumberNotYet', '尚未建立')
        }), /*#__PURE__*/_jsx(EditOrgClientProfile, {
          real_name: real_name,
          gender: gender,
          birthday: birthday || clientBirthday,
          identity_number: identity_number,
          record_number: record_number,
          client_id: client_id,
          special_note: special_note,
          allergy_note: allergy_note,
          profileId: id,
          name: name,
          country: country,
          city: city,
          street: street,
          refetch: refetch,
          mobile: identity === null || identity === void 0 ? void 0 : (_identity$data = identity.data) === null || _identity$data === void 0 ? void 0 : _identity$data.phone,
          e2eid: "Columns_BookingColumns_EditOrgClientProfile",
          children: /*#__PURE__*/_jsx(Stack, {
            w: "4",
            h: "4",
            e2eid: "Columns_BookingColumns_Stack",
            children: /*#__PURE__*/_jsx(EditIcon, {
              color: "brand",
              e2eid: "Columns_BookingColumns_EditIcon"
            })
          })
        })]
      });
    }
  }, {
    header: t('common:normal.booking_phone', 'SB手機'),
    id: 'info.formattedPhone',
    accessorFn: nestedAccessor('info.formattedPhone'),
    size: 140,
    filterFn: filterFnCollection.text,
    meta: {
      filterVariant: 'text'
    },
    cell: renderTooltipCell
  }, {
    header: t('common:normal.booking_phone', 'SB手機'),
    id: 'info.phone',
    accessorFn: nestedAccessor('info.phone'),
    size: 140,
    filterFn: filterFnCollection.text,
    meta: {
      filterVariant: 'text'
    },
    cell: renderTooltipCell
  }, {
    header: t('common:table.questionnaireStatus', '問卷狀態'),
    id: 'surveyStatus',
    accessorKey: 'surveyStatus',
    size: 140,
    filterFn: filterFnCollection.exact,
    meta: {
      filterVariant: 'select',
      selectFilterProps: {
        options: SURVEY_STATUS_CODES_LIST.map(function (key) {
          return {
            label: t("common:surveyStatus.".concat(key), key),
            value: key
          };
        }),
        optionWithTooltip: true
      }
    },
    cell: function cell(info) {
      var value = info.getValue();
      var color = getSurveyStatusColor(value);
      var text = t("common:surveyStatus.".concat(value), value);
      return /*#__PURE__*/_jsx(Tooltip, {
        label: text,
        e2eid: "Columns_BookingColumns_Tooltip",
        children: /*#__PURE__*/_jsx(Text, {
          isTruncated: true,
          as: "div",
          color: color,
          e2eid: "Columns_BookingColumns_Text",
          children: text
        })
      });
    }
  }, {
    header: t(getConsultationTreatmentWording('bookingItemText'), '預約項目'),
    id: 'service_name',
    accessorKey: 'service_name',
    size: 160,
    cell: renderTooltipCell,
    filterFn: filterFnCollection.text,
    meta: {
      filterVariant: 'select',
      selectFilterProps: {
        options: serviceNameList,
        optionWithTooltip: true
      }
    }
  }, {
    header: t(getConsultationTreatmentWording('bookingPrincipalText'), '負責人'),
    id: 'provider_name',
    accessorKey: 'provider_name',
    size: 160,
    cell: renderTooltipCell,
    filterFn: filterFnCollection.text,
    meta: {
      filterVariant: 'select',
      selectFilterProps: {
        options: providerList
      },
      editable: {
        renderEditCell: function renderEditCell(value, setValue, isDisabled) {
          return isCofit ? /*#__PURE__*/_jsx(Select, {
            value: cofitProviderList.find(function (option) {
              return option.value === value;
            }),
            onChange: function onChange(option) {
              return setValue(option.value);
            },
            options: cofitProviderList,
            placeholder: t('common:form.pleaseSelect', '請選擇'),
            isDisabled: !BranchConstants.ENABLE_BOOKING_PROVIDER || !can({
              type: 'data',
              subject: 'branch_visit',
              action: 'update',
              property: 'provider_name'
            }) || isDisabled,
            backgroundColor: "white",
            optionWithTooltip: true,
            e2eid: "Columns_BookingColumns_Select"
          }) : /*#__PURE__*/_jsx(DebouncedInput, {
            value: value,
            onChange: setValue,
            placeholder: "-",
            isDisabled: !BranchConstants.ENABLE_BOOKING_PROVIDER || !can({
              type: 'data',
              subject: 'branch_visit',
              action: 'update',
              property: 'provider_name'
            }) || isDisabled,
            backgroundColor: "white",
            e2eid: "Columns_BookingColumns_DebouncedInput"
          });
        }
      }
    }
  }, {
    header: t('common:normal.check_status', '確認狀態'),
    id: 'confirmed_at',
    accessorKey: 'confirmed_at',
    size: 120,
    cell: function cell(info) {
      var value = info.getValue();
      return /*#__PURE__*/_jsx(VStack, {
        w: "full",
        justify: "center",
        alignItems: "center",
        e2eid: "Columns_BookingColumns_VStack",
        children: /*#__PURE__*/_jsx(Checkbox, {
          isChecked: Boolean(value),
          isDisabled: !can({
            type: 'data',
            subject: 'branch_visit',
            action: 'update',
            property: 'confirmed_at'
          }),
          onChange: /*#__PURE__*/function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
              var checked;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      checked = e.target.checked;
                      _context.next = 3;
                      return API.updateBranchVisit(info.row.original.id, {
                        confirmed_at: checked ? new Date().toISOString() : null
                      });

                    case 3:
                      refetch();

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref12.apply(this, arguments);
            };
          }(),
          e2eid: "Columns_BookingColumns_Checkbox"
        })
      });
    },
    filterFn: filterFnCollection.isNil,
    meta: {
      filterVariant: 'select',
      selectFilterProps: {
        placeholder: t('common:normal.filter', '篩選'),
        options: [{
          label: t('common:confirmed', '已確認'),
          value: 'isNotNil'
        }, {
          label: t('common:unconfirmed', '未確認'),
          value: 'isNil'
        }]
      },
      editable: {
        renderEditCell: function renderEditCell(value, setValue, isDisabled) {
          return /*#__PURE__*/_jsx(HStack, {
            justifyContent: "center",
            e2eid: "Columns_BookingColumns_HStack",
            children: /*#__PURE__*/_jsx(Checkbox, {
              isDisabled: !can({
                type: 'data',
                subject: 'branch_visit',
                action: 'update',
                property: 'confirmed_at'
              }) || isDisabled,
              isChecked: Boolean(value),
              onChange: function onChange(e) {
                var checked = e.target.checked;
                setValue === null || setValue === void 0 ? void 0 : setValue(checked ? new Date().toISOString() : null);
              },
              e2eid: "Columns_BookingColumns_Checkbox"
            })
          });
        }
      }
    }
  }, {
    header: t('booking:therapyType', '療程種類'),
    id: 'data.therapy_type',
    accessorFn: nestedAccessor('data.therapy_type'),
    size: 160,
    cell: function cell(info) {
      var value = getTherapyTypeText(t, info.getValue());
      return /*#__PURE__*/_jsx(Tooltip, {
        label: value,
        e2eid: "Columns_BookingColumns_Tooltip",
        children: /*#__PURE__*/_jsx(Text, {
          isTruncated: true,
          e2eid: "Columns_BookingColumns_Text",
          children: value
        })
      });
    },
    filterFn: filterFnCollection.text,
    meta: {
      editable: {
        renderEditCell: function renderEditCell(value, setValue, isDisabled) {
          return /*#__PURE__*/_jsx(Select, {
            value: therapyTypeOptions.find(function (option) {
              return option.value === value;
            }),
            onChange: function onChange(option) {
              return setValue(option.value);
            },
            options: therapyTypeOptions,
            placeholder: t('common:form.pleaseSelect', '請選擇'),
            isDisabled: isDisabled,
            e2eid: "Columns_BookingColumns_Select"
          });
        }
      },
      bulkUpdate: {
        options: therapyTypeOptions
      },
      filterVariant: 'select',
      selectFilterProps: {
        options: therapyTypeOptions
      }
    }
  }, {
    header: t('booking:therapyStage', '療程階段'),
    id: 'data.therapy_stage',
    accessorFn: nestedAccessor('data.therapy_stage'),
    size: 120,
    filterFn: filterFnCollection.text,
    cell: renderTooltipCell,
    meta: {
      editable: {
        renderEditCell: function renderEditCell(value, setValue, isDisabled) {
          return /*#__PURE__*/_jsx(Select, {
            value: therapyStageOptions.find(function (option) {
              return option.value === value;
            }),
            onChange: function onChange(option) {
              return setValue(option.value);
            },
            options: therapyStageOptions,
            placeholder: t('common:form.pleaseSelect', '請選擇'),
            isDisabled: isDisabled,
            e2eid: "Columns_BookingColumns_Select_26"
          });
        }
      },
      bulkUpdate: {
        options: therapyStageOptions
      },
      filterVariant: 'select',
      selectFilterProps: {
        options: therapyStageOptions
      }
    }
  }, {
    header: t('booking:actual_project', '實際項目'),
    id: 'data.visit_purposes',
    accessorFn: nestedAccessor('data.visit_purposes'),
    size: 200,
    cell: function cell(info) {
      var value = info.getValue().map(function (visitPurposeValue) {
        return getVisitPurposeText(t, visitPurposeValue);
      }).join(',');
      return /*#__PURE__*/_jsx(Tooltip, {
        label: value,
        e2eid: "Columns_BookingColumns_Tooltip",
        children: /*#__PURE__*/_jsx(Text, {
          isTruncated: true,
          e2eid: "Columns_BookingColumns_Text",
          children: value
        })
      });
    },
    filterFn: filterFnCollection.text,
    meta: {
      editable: {
        renderEditCell: function renderEditCell(value, setValue, isDisabled) {
          return /*#__PURE__*/_jsx(Select, {
            optionWithTooltip: true,
            value: visitPurposeOptions.filter(function (option) {
              return value.includes(option.value);
            }),
            onChange: function onChange(options) {
              return setValue(options.map(function (option) {
                return option.value;
              }));
            },
            options: visitPurposeOptions,
            placeholder: t('common:form.pleaseSelect', '請選擇'),
            isMulti: true,
            isDisabled: !can({
              type: 'data',
              subject: 'branch_visit',
              action: 'update',
              property: 'visit_purposes'
            }) || isDisabled,
            isClearable: false,
            closeMenuOnSelect: false,
            showTooltip: true,
            e2eid: "Columns_BookingColumns_Select"
          });
        }
      },
      getDisplayValue: function getDisplayValue(values) {
        return values.join(',');
      },
      bulkUpdate: {
        isMulti: true,
        options: visitPurposeOptions
      },
      filterVariant: 'select',
      selectFilterProps: {
        options: visitPurposeOptions,
        optionWithTooltip: true
      }
    }
  }, {
    header: t('common:normal.remark', '備註'),
    id: 'note',
    accessorKey: 'note',
    size: 160,
    cell: function cell(info) {
      return /*#__PURE__*/_jsxs(Editable, {
        defaultValue: info.getValue(),
        onEdit: function onEdit() {
          return setIsInPollingMode(false);
        },
        onSubmit: function onSubmit(value) {
          return branchVisitChangeHandler('note', info.row.original.id)(value);
        },
        placeholder: "-",
        e2eid: "Columns_BookingColumns_Editable",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          label: info.getValue(),
          e2eid: "Columns_BookingColumns_Tooltip",
          children: /*#__PURE__*/_jsx(EditablePreview, {
            w: "full",
            isTruncated: true,
            e2eid: "Columns_BookingColumns_EditablePreview"
          })
        }), /*#__PURE__*/_jsx(Input, {
          as: EditableInput,
          e2eid: "Columns_BookingColumns_Input"
        })]
      }, info.getValue());
    },
    meta: {
      editable: {
        renderEditCell: function renderEditCell(value, setValue, isDisabled) {
          return /*#__PURE__*/_jsx(DebouncedInput, {
            value: value,
            onChange: setValue,
            placeholder: "-",
            isDisabled: isDisabled,
            backgroundColor: "white",
            e2eid: "Columns_BookingColumns_DebouncedInput"
          });
        }
      }
    }
  }, getUserColumnDef('data.doctor_id', t('common:normal.response_doctor', '負責醫師'), t, doctors), getUserColumnDef('data.master_dietician_id', t('common:normal.chief_dietician', '主營養師'), t, dieticians), getUserColumnDef('data.master_dietician_delegate_id', t('common:normal.chief_dietician_agent', '主營養師（代）'), t, dieticians), getUserColumnDef('data.pre_rd_id', t('common:normal.pre_dietician', '前諮營養師'), t, dieticians), getUserColumnDef('data.salesperson_id', t('common:normal.health_secretary', '健康秘書'), t, salespeople), getUserColumnDef('data.salesperson_delegate_id', t('common:normal.health_secretary_agent', '健康秘書（代）'), t, salespeople), {
    header: t('common:communication.lineStatus', 'LINE狀態'),
    id: 'lineBoundStatus',
    accessorKey: 'lineBoundStatus',
    size: 160,
    cell: function cell(info) {
      var isLineAccountBound = info.row.original.isLineAccountBound;
      return /*#__PURE__*/_jsx(Badge, {
        variant: "subtle",
        colorScheme: isLineAccountBound ? 'green' : 'gray',
        fontSize: "md",
        fontWeight: "normal",
        e2eid: "Columns_BookingColumns_Badge",
        children: info.getValue()
      });
    },
    filterFn: filterFnCollection.text,
    meta: {
      filterVariant: 'select',
      selectFilterProps: {
        options: R.map(function (key) {
          return t("common:status.".concat(key), key);
        })(commonSettings.BINDING_STATUSES)
      }
    }
  }, {
    header: t('common:communication.pvideoCall', '視訊'),
    accessorKey: 'videoCall',
    size: 56,
    cell: function cell(_ref13) {
      var row = _ref13.row;
      var original = row.original;
      var id = original.id,
          online = original.online,
          online_url = original.online_url;

      var handleConvertToOnline = /*#__PURE__*/function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (id) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return");

                case 2:
                  _context2.next = 4;
                  return API.branchVisitConvertToOnline(id);

                case 4:
                  refetch();

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function handleConvertToOnline() {
          return _ref14.apply(this, arguments);
        };
      }();

      var handleLinkToVideoCall = function handleLinkToVideoCall() {
        if (!online_url) return;
        window.open(online_url);
      };

      var renderVideoButton = function renderVideoButton() {
        if (online) {
          return /*#__PURE__*/_jsx(TaskIconButton, {
            variant: "ghost",
            boxSize: "10",
            onConfirm: handleLinkToVideoCall,
            "aria-label": "videoCall",
            icon: /*#__PURE__*/_jsx(VideoIcon, {
              fill: "orange.brand",
              e2eid: "Columns_BookingColumns_VideoIcon"
            }),
            colorScheme: "brandScheme",
            confirmButtonText: t('common:status.readyForVideo', '準備好了，進入視訊'),
            modalTitle: t('common:attention', '注意'),
            modalMessage: t('common:useCofitAccount', '視訊時，請務必選用「COFIT 營養師」這個 Google 帳號進行視訊面談'),
            e2eid: "Columns_BookingColumns_TaskIconButton"
          });
        } else {
          return /*#__PURE__*/_jsx(VideoActionButton, {
            variant: "ghost",
            "aria-label": "videoCall",
            icon: /*#__PURE__*/_jsx(TurnsIntoToVideoIcon, {
              fill: "blue.400",
              e2eid: "Columns_BookingColumns_TurnsIntoToVideoIcon"
            }),
            colorScheme: "blue.400",
            onConvertToOnline: handleConvertToOnline,
            onLinkToVideoCall: handleLinkToVideoCall,
            boxSize: "10",
            e2eid: "Columns_BookingColumns_VideoActionButton"
          });
        }
      };

      return renderVideoButton();
    }
  }, {
    header: t('booking:cancel_booking', '取消預約'),
    accessorKey: 'cancel',
    size: 96,
    cell: function cell(_ref15) {
      var row = _ref15.row;
      var original = row.original;
      var id = original.id,
          state = original.state,
          client = original.client;
      return /*#__PURE__*/_jsx(Tooltip, {
        label: t('booking:error.cannot_cancel_checked_in', '無法取消已報到的預約'),
        isDisabled: state !== BranchVisitStates.checked_in,
        shouldWrapChildren: true,
        e2eid: "Columns_BookingColumns_Tooltip",
        children: /*#__PURE__*/_jsx(TaskButton, {
          minW: "70px",
          onConfirm: function onConfirm() {
            return cancelHandler(id);
          },
          disableButton: state === BranchVisitStates.checked_in,
          buttonText: t('common:button.cancel', '取消'),
          confirmButtonText: t('booking:confirm_cancellation', '確認取消'),
          modalTitle: t('booking:cancel_confirmation', '取消確認'),
          modalMessage: t('booking:cancel_booking_confirmation', "\u78BA\u5B9A\u70BA\u300E".concat(client === null || client === void 0 ? void 0 : client.name, "\u300F\u53D6\u6D88\u9810\u7D04\u55CE\uFF1F"), {
            client_name: client === null || client === void 0 ? void 0 : client.name
          }),
          variant: "ghost",
          e2eid: "Columns_BookingColumns_TaskButton"
        })
      });
    }
  }, {
    header: t('client:normal.appointmentProcess', '預約歷程'),
    accessorKey: 'appointmentProcess',
    size: 96,
    cell: function cell(_ref16) {
      var row = _ref16.row;
      var original = row.original;
      var info = original.info,
          client_id = original.client_id;
      return /*#__PURE__*/_jsx(IconButton, {
        "aria-label": "View Appointment Record",
        icon: /*#__PURE__*/_jsx(TimeIcon, {
          boxSize: 4,
          e2eid: "Columns_BookingColumns_TimeIcon"
        }),
        size: "sm",
        colorScheme: "gray",
        onClick: handleRecordButtonClick({
          real_name: info.booking_name,
          client_id: client_id
        }),
        e2eid: "Columns_BookingColumns_IconButton"
      });
    }
  }, {
    header: t(getConsultationTreatmentWording('soapRecordText'), '諮詢診療'),
    accessorKey: 'enter',
    size: 96,
    cell: function cell(_ref17) {
      var row = _ref17.row;
      var original = row.original;
      var client_id = original.client_id;

      var handleEnter = function handleEnter() {
        navigate(MenuID.client, {
          clientID: client_id
        }, {
          newTab: true
        });
      };

      return /*#__PURE__*/_jsx(EnterButton, {
        minW: "70px",
        variant: "ghost",
        rightIcon: /*#__PURE__*/_jsx(ChevronRightIcon, {
          boxSize: "1.3em",
          e2eid: "Columns_BookingColumns_ChevronRightIcon"
        }),
        handleClick: handleEnter,
        e2eid: "Columns_BookingColumns_EnterButton",
        children: t('common:button.enter')
      });
    }
  }, {
    header: t('common:normal.onboardStatus', '報到狀態'),
    accessorKey: 'checkIn',
    size: 96,
    cell: function cell(_ref18) {
      var row = _ref18.row;
      var original = row.original;
      var id = original.id,
          state = original.state,
          client = original.client,
          check_in_time = original.check_in_time;

      var handleOnboard = /*#__PURE__*/function () {
        var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (id) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  _context3.next = 4;
                  return API.checkIn(id);

                case 4:
                  refetch();

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function handleOnboard() {
          return _ref19.apply(this, arguments);
        };
      }();

      if (state === BranchVisitStates.checked_in) {
        return /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          e2eid: "Columns_BookingColumns_Text",
          children: utcDateString2localDateString(check_in_time, 'HH:mm')
        });
      }

      return /*#__PURE__*/_jsx(TaskButton, {
        minW: "70px",
        onConfirm: handleOnboard,
        disableButton: !can({
          type: 'data',
          subject: 'branch_visit',
          action: 'update',
          property: 'state'
        }),
        buttonText: can({
          type: 'data',
          subject: 'branch_visit',
          action: 'update',
          property: 'state'
        }) ? t('common:normal.onboard', '報到') : t('common:normal.notOnboard', '未報到'),
        confirmButtonText: t('common:button.confirmCheckIn', '確認報到'),
        modalTitle: t('common:normal.confirmOnboarded', '報到確認'),
        modalMessage: t('common:normal.willOnboardSomeone', "\u78BA\u5B9A\u70BA\u300E".concat(client === null || client === void 0 ? void 0 : client.name, "\u300F\u8FA6\u7406\u5831\u5230?"), {
          name: client === null || client === void 0 ? void 0 : client.name
        }),
        e2eid: "Columns_BookingColumns_TaskButton"
      });
    }
  }];
};